import { useCallback, useEffect, useMemo, useState } from 'react';
import { isEqual, omit, some, keys } from 'underscore';
import { getParameter, getDomain } from '@bingads-webui/url-util';
import { useVideoClipTaskPoller, StatusEnum } from '@bingads-webui-campaign-react/copilot-domain-data-service';

import { getTextSizeLimitation, ColorTypeEnum } from './util';

// for testing
const isSelenium = getParameter('ise2etest') === 'true';
const isLocal = getDomain(window.location.href) === 'localhost';
const mock = isSelenium === true || isLocal;
const defaultColor = '#FFFFFF';
const defaultTextData = {
  font: 'Arial',
  color: defaultColor,
  fontWeight: 'Normal',
};

// mock
const checkMockCall = (scene) => {
  let returnValue = true;
  if (!scene.text.length || scene.text[0] !== 'TestText') {
    returnValue = false;
  }
  const { textData } = scene;
  if (!textData.length || textData[0].font !== 'Arial' || textData[0].fontWeight !== 'Normal') {
    returnValue = false;
  }
  return returnValue;
};
const mockEditResponse = {
  recommendationId: '14716601-9749-4fb5-a700-a00860f3a65c',
  url: 'https://mmastoragedev.blob.core.windows.net/testdata/mock-project-2.json',
  recommendationFormat: 'Clipchamp',
  thumbnailUrl: 'https://mmastoragedev.blob.core.windows.net/testdata/images/recommendation_test_DO_NOT_DEL/video-thumbnail.jpeg',
  videoMetadata: {
    width: 1280,
    height: 720,
    durationInMs: 15000,
  },
  template: {
    templateId: 'a3f900b6-942a-4b55-bb1d-87bae12229f0',
    audio: {
      category: 'Chill',
      fileName: 'abc.mp3',
      audioName: 'abc',
    },
    scenes: [
      {
        images: [
          'https://mmastoragedev.blob.core.windows.net/testdata/images/recommendation_test_DO_NOT_DEL/autvideo_1.jpg',
        ],
        imageData: [
          {
            targetWidth: 720,
            targetHeight: 1280,
            itemId: 'af0d9795-2394-4e70-a366-6bf4a3fb0959',
          },
        ],
        text: [
          'Premium Thai Food',
          'Get your spice on',
        ],
        textData: [
          {
            font: 'Arial',
            color: '#FFFFFF',
            maxLength: 30,
            itemId: 'c77085f6-e229-4004-ab15-2c3605d5ae9a',
          },
          {
            font: 'Arial',
            color: '#FFFFFF',
            maxLength: 50,
            itemId: '0decb36c-8048-4eaa-926a-3ca71d126734',
          },
        ],
        logos: [
          'https://mmastoragedev.blob.core.windows.net/testdata/images/recommendation_test_DO_NOT_DEL/logo.png',
        ],
        logoData: [
          {
            targetWidth: 500,
            targetHeight: 500,
            itemId: 'd4505e7a-d552-4b8a-bee6-eb390dd31d74',
          },
        ],
        keyFrame: {
          templateId: 'a3f900b6-942a-4b55-bb1d-87bae12229f0',
          url: 'https://mmastoragedev.blob.core.windows.net/testdata/images/recommendation_test_DO_NOT_DEL/keyframe1.png',
        },
      },
    ],
  },
};

// const mock9By16Response = {
//   recommendationId: '14716601-9749-4fb5-a700-a00860f3a65c',
//   url: 'https://aggsvcstoragedev.z13.web.core.windows.net/clipchamp/mocks/mock_vertical.clipchamp',
//   recommendationFormat: 'Clipchamp',
//   thumbnailUrl: 'https://mmastoragedev.blob.core.windows.net/testdata/images/recommendation_test_DO_NOT_DEL/video-thumbnail.jpeg',
//   videoMetadata: {
//     width: 720,
//     height: 1280,
//     durationInMs: 15000,
//   },
//   template: {
//     templateId: 'a3f900b6-942a-4b55-bb1d-87bae12229f0',
//     height: 1280,
//     width: 720,
//     audio: {
//       category: 'Chill',
//       fileName: 'abc.mp3',
//       audioName: 'abc',
//     },
//     scenes: [
//       {
//         images: [
//           'https://www.apple.com/v/iphone-16/f/images/overview/photographic-styles/megapixels__clulnpeenivm_large.png',
//         ],
//         imageData: [
//           {
//             targetWidth: 720,
//             targetHeight: 1280,
//             itemId: 'af0d9795-2394-4e70-a366-6bf4a3fb0959',
//           },
//         ],
//         text: [
//           'Premium Thai Food',
//           'Get your spice on',
//         ],
//         textData: [
//           {
//             font: 'Arial',
//             color: '#FFFFFF',
//             maxLength: 30,
//             itemId: 'c77085f6-e229-4004-ab15-2c3605d5ae9a',
//           },
//           {
//             font: 'Arial',
//             color: '#FFFFFF',
//             maxLength: 50,
//             itemId: '0decb36c-8048-4eaa-926a-3ca71d126734',
//           },
//         ],
//         logos: [
//           'https://www.apple.com/v/iphone-16/f/images/overview/photographic-styles/megapixels__clulnpeenivm_large.png',
//         ],
//         logoData: [
//           {
//             targetWidth: 500,
//             targetHeight: 500,
//             itemId: 'd4505e7a-d552-4b8a-bee6-eb390dd31d74',
//           },
//         ],
//         keyFrame: {
//           templateId: 'a3f900b6-942a-4b55-bb1d-87bae12229f0',
//           url: 'https://www.apple.com/v/iphone-16/f/images/overview/photographic-styles/megapixels__clulnpeenivm_large.png',
//         },
//       },
//       {
//         images: [
//           'https://aggsvcstoragedev.z13.web.core.windows.net/auto_image/8c374d27-5762-46d3-990b-44adecee6858.jpeg',
//         ],
//         imageData: [
//           {
//             targetWidth: 720,
//             targetHeight: 1280,
//             itemId: 'af0d9795-2394-4e70-a366-6bf4a3fb0959',
//           },
//         ],
//         text: [
//           'Premium Thai Food',
//           'Get your spice on',
//         ],
//         textData: [
//           {
//             font: 'Arial',
//             color: '#FFFFFF',
//             maxLength: 30,
//             itemId: 'c77085f6-e229-4004-ab15-2c3605d5ae9a',
//           },
//           {
//             font: 'Arial',
//             color: '#FFFFFF',
//             maxLength: 50,
//             itemId: '0decb36c-8048-4eaa-926a-3ca71d126734',
//           },
//         ],
//         logos: [
//           'https://aggsvcstoragedev.z13.web.core.windows.net/auto_image/8c374d27-5762-46d3-990b-44adecee6858.jpeg',
//         ],
//         logoData: [
//           {
//             targetWidth: 500,
//             targetHeight: 500,
//             itemId: 'd4505e7a-d552-4b8a-bee6-eb390dd31d74',
//           },
//         ],
//         keyFrame: {
//           templateId: 'a3f900b6-942a-4b55-bb1d-87bae12229f0',
//           url: 'https://aggsvcstoragedev.z13.web.core.windows.net/auto_image/8c374d27-5762-46d3-990b-44adecee6858.jpeg',
//         },
//       },
//       {
//         images: [
//           'https://mmastoragedev.blob.core.windows.net/testdata/images/recommendation_test_DO_NOT_DEL/autvideo_1.jpg',
//         ],
//         imageData: [
//           {
//             targetWidth: 720,
//             targetHeight: 1280,
//             itemId: 'af0d9795-2394-4e70-a366-6bf4a3fb0959',
//           },
//         ],
//         text: [
//           'Premium Thai Food',
//           'Get your spice on',
//         ],
//         textData: [
//           {
//             font: 'Arial',
//             color: '#FFFFFF',
//             maxLength: 30,
//             itemId: 'c77085f6-e229-4004-ab15-2c3605d5ae9a',
//           },
//           {
//             font: 'Arial',
//             color: '#FFFFFF',
//             maxLength: 50,
//             itemId: '0decb36c-8048-4eaa-926a-3ca71d126734',
//           },
//         ],
//         logos: [
//           'https://www.apple.com/v/iphone-16/f/images/overview/photographic-styles/megapixels__clulnpeenivm_large.png',
//         ],
//         logoData: [
//           {
//             targetWidth: 500,
//             targetHeight: 500,
//             itemId: 'd4505e7a-d552-4b8a-bee6-eb390dd31d74',
//           },
//         ],
//         keyFrame: {
//           templateId: 'a3f900b6-942a-4b55-bb1d-87bae12229f0',
//           url: 'https://www.apple.com/v/iphone-16/f/images/overview/photographic-styles/megapixels__clulnpeenivm_large.png',
//         },
//       },
//       {
//         images: [
//           'https://www.apple.com/v/iphone-16/f/images/overview/photographic-styles/megapixels__clulnpeenivm_large.png',
//         ],
//         imageData: [
//           {
//             targetWidth: 720,
//             targetHeight: 1280,
//             itemId: 'af0d9795-2394-4e70-a366-6bf4a3fb0959',
//           },
//         ],
//         text: [
//           'Premium Thai Food',
//           'Get your spice on',
//         ],
//         textData: [
//           {
//             font: 'Arial',
//             color: '#FFFFFF',
//             maxLength: 30,
//             itemId: 'c77085f6-e229-4004-ab15-2c3605d5ae9a',
//           },
//           {
//             font: 'Arial',
//             color: '#FFFFFF',
//             maxLength: 50,
//             itemId: '0decb36c-8048-4eaa-926a-3ca71d126734',
//           },
//         ],
//         logos: [
//           'https://www.apple.com/v/iphone-16/f/images/overview/photographic-styles/megapixels__clulnpeenivm_large.png',
//         ],
//         logoData: [
//           {
//             targetWidth: 500,
//             targetHeight: 500,
//             itemId: 'd4505e7a-d552-4b8a-bee6-eb390dd31d74',
//           },
//         ],
//         keyFrame: {
//           templateId: 'a3f900b6-942a-4b55-bb1d-87bae12229f0',
//           url: 'https://www.apple.com/v/iphone-16/f/images/overview/photographic-styles/megapixels__clulnpeenivm_large.png',
//         },
//       },
//       {
//         images: [
//           'https://www.apple.com/v/iphone-16/f/images/overview/photographic-styles/megapixels__clulnpeenivm_large.png',
//         ],
//         imageData: [
//           {
//             targetWidth: 720,
//             targetHeight: 1280,
//             itemId: 'af0d9795-2394-4e70-a366-6bf4a3fb0959',
//           },
//         ],
//         text: [
//           'Premium Thai Food',
//           'Get your spice on',
//         ],
//         textData: [
//           {
//             font: 'Arial',
//             color: '#FFFFFF',
//             maxLength: 30,
//             itemId: 'c77085f6-e229-4004-ab15-2c3605d5ae9a',
//           },
//           {
//             font: 'Arial',
//             color: '#FFFFFF',
//             maxLength: 50,
//             itemId: '0decb36c-8048-4eaa-926a-3ca71d126734',
//           },
//         ],
//         logos: [
//           'https://www.apple.com/v/iphone-16/f/images/overview/photographic-styles/megapixels__clulnpeenivm_large.png',
//         ],
//         logoData: [
//           {
//             targetWidth: 500,
//             targetHeight: 500,
//             itemId: 'd4505e7a-d552-4b8a-bee6-eb390dd31d74',
//           },
//         ],
//         keyFrame: {
//           templateId: 'a3f900b6-942a-4b55-bb1d-87bae12229f0',
//           url: 'https://www.apple.com/v/iphone-16/f/images/overview/photographic-styles/megapixels__clulnpeenivm_large.png',
//         },
//       },
//     ],
//   },
// };

const useRecommendations = ({ copilotDataService }) => {
  const { editVideoAdsAssetRecommendations, fetchAssets } = copilotDataService;
  // const fetchEditedVideo = useMemo(() => _.memoize(_.throttle(editVideoAdsAssetRecommendations, 100)), [editVideoAdsAssetRecommendations]);

  const generateVideo = ({
    scenes, video, styles, audio,
  }) => {
    const { template } = video;
    const { templateId } = template;
    const newVideoMetaData = {
      template: {
        templateId,
        audio,
        scenes: scenes.map((scene) => {
          const {
            images, imageData, text, textData, logos, logoData,
          } = scene;
          return {
            images,
            imageData,
            text,
            textData,
            logos,
            logoData,
          };
        }),
      },
    };
    const ads = newVideoMetaData;
    return editVideoAdsAssetRecommendations(ads, false, styles)
      .then((res) => {
        if (mock === true) {
          if (ads && ads.template && ads.template.scenes && ads.template.scenes.length) {
            const isValid = checkMockCall(ads.template.scenes[0]);
            return isValid ? mockEditResponse : null;
          }
        }
        if (res.data && res.data.ads && res.data.ads.length > 0) {
          return res.data.ads[0];
        }
        return res;
      })
      .catch(error => error);
  };

  return {
    generateVideo,
    fetchAssets,
  };
};

const extractStylesFromScenes = (scenes) => {
  const { textData } = scenes[0].effective;
  const { font, color, fontWeight } = textData && textData.length > 0 ? textData[0] : defaultTextData;
  return {
    font,
    color,
    fontWeight,
  };
};

// even the same scene, the keyFrame url could be different.
const isEqualScene = (scene1, scene2) => isEqual(omit(scene1, 'keyFrame'), omit(scene2, 'keyFrame'));
const isSceneChanged = scene => (scene.effective ? !isEqualScene(scene.updating, scene.effective) : !isEqualScene(scene.original, scene.updating));
const isVideoChanged = scenes => scenes.some(scene => isSceneChanged(scene));

// For the scene related state, we could save them into a single scene object, and then use the id to locate the scene object.
// Text, Image, KeyFrame are the main scene properties that could be changed. (KeyFrame is from the API call. Text and Image are also included in the API calls.)
// Original, Updating and Effective are for checking if the scene has been changed.
// For the video, we could save the video URL and it's related scenes.
// To check if the video could be generated, we could check if the scenes have been changed.
// If the scenes have been changed, we could generate the video.
// If the scenes are not changed, we could apply the video and it's related scenes (if we want to save the metadata).

// videoMetaData is the original video.
export const useEditVideoAdsViewState = ({
  videoMetaData,
  copilotDataService,
  logger,
  i18n,
  isCTV,
  brandKit,
  finalUrl,
  activity,
  showVideoTemplateSummaryBarControl,
  imageAnimationEnabled,
}) => {
  const {
    generateVideo,
    fetchAssets,
  } = useRecommendations({
    copilotDataService,
  });

  // const mockClipsRes = {
  //   data: {
  //     VideoClipTasksInfo: [
  //       {
  //         GenerateVideoClipData: {
  //           GenerationType: 'ImageToVideo',
  //           ImageUrl: 'https://aggsvcstorage.blob.core.windows.net/stock-images/19WGK2ZLT4DLcjUQoF-spmf3p968YIlwG.jpg',
  //           Height: 1080,
  //           Width: 1920,
  //           MaxCountVideo: 4,
  //           FinalURL: 'www.nike.com',
  //           Texts: [
  //             'text from the scene',
  //           ],
  //           UserPrompt: {
  //             prompts: [
  //               'spin the shoe',
  //             ],
  //           },
  //         },
  //         TaskId: 'a92ab43d-1431-41bf-a392-c9a5336c9457',
  //         Status: 'InProgress',
  //       },
  //     ],
  //   },
  // };

  // const mockStatusRes = {
  //   0: {
  //     '@odata.context': 'http://localhost:10877/Advertiser/v2/$metadata#Model.GenerateVideoClipsStatusResponse',
  //     Data: {
  //       VideoClipsStatus: [
  //         {
  //           Status: 'Pending',
  //           Progress: 100,
  //           TaskId: 'task1',
  //           CreatedAt: null,
  //           ErrorCode: null,
  //           ErrorMessage: null,
  //           RecommendedVideoClips: [
  //             {
  //               Source: 'AI Generated',
  //               Url: 'https://aggsvcstorage.z13.web.core.windows.net/testdata/images/recommendation_test_DO_NOT_DEL/video-sample.mp4',
  //               ModelSource: 'KlingAI',
  //             },
  //           ],
  //         },
  //         {
  //           Status: 'Pending',
  //           Progress: 100,
  //           TaskId: 'task2',
  //           CreatedAt: null,
  //           ErrorCode: '123',
  //           ErrorMessage: 'Model did not respond',
  //           RecommendedVideoClips: [
  //             {
  //               Source: 'AI Generated',
  //               Url: null,
  //               ModelSource: 'KlingAI',
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     Errors: [],
  //   },

  //   1: {
  //     '@odata.context': 'http://localhost:10877/Advertiser/v2/$metadata#Model.GenerateVideoClipsStatusResponse',
  //     Data: {
  //       VideoClipsStatus: [
  //         {
  //           Status: 'Completed',
  //           Progress: 100,
  //           TaskId: 'task1',
  //           CreatedAt: null,
  //           ErrorCode: null,
  //           ErrorMessage: null,
  //           RecommendedVideoClips: [
  //             {
  //               Source: 'AI Generated',
  //               Url: 'https://aggsvcstorage.z13.web.core.windows.net/testdata/images/recommendation_test_DO_NOT_DEL/video-sample.mp4',
  //               ModelSource: 'KlingAI',
  //             },
  //           ],
  //         },
  //         {
  //           Status: 'Failed',
  //           Progress: 100,
  //           TaskId: 'task2',
  //           CreatedAt: null,
  //           ErrorCode: '123',
  //           ErrorMessage: 'Model did not respond',
  //           RecommendedVideoClips: [
  //             {
  //               Source: 'AI Generated',
  //               Url: null,
  //               ModelSource: 'KlingAI',
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     Errors: [],
  //   },
  // };

  // const mockRepository = {
  //   generateVideoClips: request => new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve(mockClipsRes);
  //     }, 1000);
  //   }),

  //   generateVideoClipsStatus: request => new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve(mockStatusRes[request.toString()] ?? mockStatusRes['1']);
  //     }, 1000);
  //   }),

  // };

  const {
    updatedClips, addTask, inProgressTaskList, cancelTask,
  } = useVideoClipTaskPoller({
    repository: copilotDataService,
    logger,
    activity,
    interval: 10000,
    imageAnimationEnabled,
  });


  const [scenes, setScenes] = useState([]);
  const [selectedSceneId, setSelectedSceneId] = useState(0); // Used to locate the scene with id
  const [video, setVideo] = useState({});
  const [audioState, setAudioState] = useState({});
  const [fontsState, setFontsState] = useState([]);
  const [palettesState, setPalettesState] = useState([]);
  const [videoUrl, setVideoUrl] = useState(videoMetaData && videoMetaData.url);
  const [videoSettings, setVideoSettings] = useState({}); // Used to store the video settings [logo, businessName]
  const [isGeneratingVideo, setIsGeneratingVideo] = useState(false);
  const [generateError, setGenerateError] = useState(undefined); // Used to show the error message
  const [recommendedAssets, setRecommendedAssets] = useState([]);
  const [isLoadingRecommendedAssets, setIsLoadingRecommendedAssets] = useState(false);
  const [copilotRecommendedAssets, setCopilotRecommendedAssets] = useState(null);
  const [ariaLiveVideoGenerateMessage, setAriaLiveVideoGenerateMessage] = useState('');
  const [animationToggleState, setAnimationToggleState] = useState([]);

  // Update current state with response from AIGC
  const updateStateFromFetchResponse = useCallback((response) => {
    // initialization from the video metadata
    const {
      scenes: scenesInner = [], businessName, audio, backgroundColor,
    } = response && response.template;
    const scenesWithIds = scenesInner.map((scene, index) => ({
      original: (scene.original ? scene.original : scene), // Original won't be overridden by updates
      updating: scene, // Used to keep track of the scene changes (the react view will modify this part)
      effective: scene, // Assume, we've already generated the scene
      id: index,
      newImages: (scene.images ? scene.images.map(imageUrl => ({ url: imageUrl, id: '' })) : []),
      newLogos: (scene.logos ? scene.logos.map(logoUrl => ({ url: logoUrl, id: '' })) : []),
    }));

    setScenes(scenesWithIds);
    setVideoUrl(response.url || response.src);
    setVideo({
      ...response,
    });
    setAudioState({
      original: audio,
      updating: audio,
      effective: audio,
    });
    const { font, color, fontWeight } = extractStylesFromScenes(scenesWithIds);
    const fonts = { font, fontWeight };
    setFontsState({
      original: fonts,
      updating: fonts,
      effective: fonts,
    });

    const palettes = [
      { Name: ColorTypeEnum.TextColor, HexCode: (color || defaultColor) },
      { Name: ColorTypeEnum.BackgroundColor, HexCode: ((backgroundColor && backgroundColor.color) || defaultColor) },
    ];
    const filteredPalettes = palettes.filter(c => c.HexCode);

    setPalettesState({
      original: filteredPalettes,
      updating: filteredPalettes,
      effective: filteredPalettes,
    });
    const videoSettingsInner = {
      businessName,
    };
    setVideoSettings({
      original: videoSettingsInner,
      updating: videoSettingsInner,
      effective: videoSettingsInner,
    });

    // fetch recommended assets
    if (finalUrl) {
      setIsLoadingRecommendedAssets(true);
      fetchAssets().then((res) => {
        if (res && res.RecommendedAssets) {
          const { RecommendedAssets, Logo } = res;
          const assetsObj = { ...RecommendedAssets, Logo: Logo || '' };
          setRecommendedAssets(assetsObj);
          setCopilotRecommendedAssets(res);
          setIsLoadingRecommendedAssets(false);
        }
      }).catch((error) => {
        logger.logTrace('Error while fetch video editor recommendations', error);
      })
        .finally(() => setIsLoadingRecommendedAssets(false));
    }
  }, [fetchAssets, finalUrl, logger]);

  useEffect(() => {
    if (videoMetaData) {
      updateStateFromFetchResponse(videoMetaData);
      if (isCTV) {
        logger.logTrace('CTV Copilot video editor: editor panel opened');
      } else {
        logger.logTrace('OLV Copilot video editor: editor panel opened');
      }
    }
  }, [logger, videoMetaData, isCTV, updateStateFromFetchResponse]);

  const createStylesRequestObject = useCallback(() => {
    // const { textColor, backgroundColor } = (palettesState && palettesState.updating) || {};
    const colorProperties = palettesState && palettesState.updating.reduce((acc, color) => {
      acc[color.Name] = color;
      return acc;
    }, {});
    const { textColor, backgroundColor } = colorProperties || {};
    const { font, fontWeight } = (fontsState && fontsState.updating) || {};
    const palettes = [{ colorType: textColor.Name, colors: [textColor.HexCode] }, { colorType: backgroundColor.Name, colors: [backgroundColor.HexCode] }];
    const fonts = [{ type: font, weight: fontWeight }];
    return { palettes, fonts };
  }, [palettesState, fontsState]);

  const generateNewVideo = useCallback((scenesInCall) => {
    setGenerateError(undefined);
    setIsGeneratingVideo(true);
    setAriaLiveVideoGenerateMessage(i18n.getString(_TL_('Updating video...')));

    const styles = createStylesRequestObject();
    const audio = (audioState && audioState.updating) || {};

    return generateVideo({
      scenes: scenesInCall.map(scene => scene.updating), video, styles, audio,
    }).then((newVideoMetaData) => {
      updateStateFromFetchResponse(newVideoMetaData);
      if (isCTV) {
        logger.logTrace('CTV Copilot video editor: video generated');
      } else {
        logger.logTrace('OLV Copilot video editor: video generated');
      }

      if (activity && activity.signal) {
        const message = `[VideoAdsEditor] - Edit Video - Generate - TemplateId:${videoMetaData.template.templateId}, AdStudio:${showVideoTemplateSummaryBarControl}`;
        activity.signal(message);
      }

      setAriaLiveVideoGenerateMessage(i18n.getString(_TL_('Video updated successfully')));
      return {
        ...newVideoMetaData,
        scenes,
        msg: 'success',
      };
    }).catch((error) => {
      const { errors } = error;
      if (errors && errors[0] && errors[0].message) {
        const err = errors[0].message;
        setGenerateError(err);
        setAriaLiveVideoGenerateMessage(err);
      } else {
        const err = i18n.getString(_TL_('Copilot has failed to generate a new video. Please try again later.'));
        setGenerateError(err);
        setAriaLiveVideoGenerateMessage(err);
      }
      return {
        msg: 'failed',
      };
    })
      .finally(() => {
        setIsGeneratingVideo(false);
      });
  }, [generateVideo, video, logger, i18n, createStylesRequestObject, audioState, isCTV, scenes, updateStateFromFetchResponse]);

  const selectedScene = useMemo(() => scenes && scenes.find(scene => scene.id === selectedSceneId), [scenes, selectedSceneId]) || {
    original: {},
    updating: {},
    effective: {},
    id: -1,
  };

  const onSceneSelected = useCallback((scene) => {
    setSelectedSceneId(scene.id);
  }, []);

  const onScenesUpdated = useCallback((updatedScenes) => {
    setScenes(updatedScenes);
  }, []);

  const onFontsUpdated = useCallback((updatedFonts) => {
    setFontsState(updatedFonts);
  }, []);

  const onPalettesUpdated = useCallback((hex, colorType) => {
    setPalettesState((prevState) => {
      const newState = { ...prevState };
      const index = newState.updating.findIndex(c => c.Name === colorType);
      if (index !== -1) {
        newState.updating[index].HexCode = hex;
      }
      return newState;
    });
  }, []);

  const handleGenerateVideo = useCallback(() => {
    generateNewVideo(scenes);
  }, [generateNewVideo, scenes]);

  const handleGenerate = useCallback(() => {
    logger.logTrace('Copilot video editor: generate button clicked');
    handleGenerateVideo();
  }, [logger, handleGenerateVideo]);

  const textErrorMessages = useMemo(() => {
    const errorMessages = {};
    scenes.forEach((scene) => {
      errorMessages[scene.id] = [];
      const updatingText = scene.updating.text;
      const maxLengthOfText = getTextSizeLimitation(scene.updating.keyFrame.templateId);
      updatingText.forEach((text, index) => {
        if (text.length > maxLengthOfText[index]) {
          errorMessages[scene.id].push(i18n.getString(_TL_('Value cannot be longer than {{maxLength}} characters'), { maxLength: maxLengthOfText[index] }));
        } else if (text.length === 0) {
          errorMessages[scene.id].push(i18n.getString(_TL_('Required field')));
        } else {
          errorMessages[scene.id].push('');
        }
      });
    });

    return errorMessages;
  }, [i18n, scenes]);

  const haveTextError = useMemo(() => {
    const haveErrorInScenes = [];
    if (textErrorMessages) {
      keys(textErrorMessages).forEach((key) => {
        haveErrorInScenes.push(some(textErrorMessages[key]));
      });
    }
    return some(haveErrorInScenes);
  }, [textErrorMessages]);

  const textErrorForSelectedScene = useMemo(() => textErrorMessages[selectedSceneId], [selectedSceneId, textErrorMessages]);

  useEffect(() => {
    if (updatedClips) {
      const clipIds = Object.keys(updatedClips);
      clipIds.forEach((clipId) => {
        const clipInfo = updatedClips[clipId];
        const {
          id, sceneId, imageUrl, imageIndex, Status, RecommendedVideoClips,
        } = clipInfo;
        if (Status === StatusEnum.COMPLETED) {
          setScenes(prevScenes => prevScenes.map((scene) => {
            if (scene.id === sceneId) {
              const imageDataToUpdate = scene && scene.updating && scene.updating.imageData && scene.updating.imageData.map((imageDataItem, index) => {
                const sceneImages = scene.updating.images;
                const sceneImageUrl = sceneImages && sceneImages[index];
                // we want to assign this video clip to the correct image based on its index, url and scene id.
                if (sceneImageUrl === imageUrl && imageIndex === index) {
                  if (animationToggleState[id] === true || animationToggleState[id] === undefined) {
                    return {
                      ...imageDataItem,
                      videoClipUrl: RecommendedVideoClips[0].Url,
                    };
                  }
                  return {
                    ...imageDataItem,
                    videoClipUrl: null,
                  };
                }
                return {
                  ...imageDataItem,
                };
              });
              return {
                ...scene,
                updating: {
                  ...scene.updating,
                  imageData: imageDataToUpdate,
                },
              };
            }
            return scene;
          }));
        }
      });
    }
  }, [updatedClips, animationToggleState]);

  const onAnimationToggled = useCallback((taskId, isToggled) => {
    setAnimationToggleState((prevState) => {
      const newState = { ...prevState };
      newState[taskId] = isToggled;
      return newState;
    });
  });

  const onImageUpdated = useCallback((images) => {
    setScenes(prevScenes => prevScenes.map((scene) => {
      if (scene.id === selectedSceneId) {
        return {
          ...scene,
          updating: {
            ...scene.updating,
            images: images.map(image => image.url),
          },
          newImages: images,
        };
      }
      return scene;
    }));
  }, [selectedSceneId]);

  const onLogoUpdated = useCallback((logos) => {
    setScenes(prevScenes => prevScenes.map((scene) => {
      if (scene.id === selectedSceneId) {
        return {
          ...scene,
          updating: {
            ...scene.updating,
            logos: logos.map(logo => logo.url),
          },
          newLogos: logos,
        };
      }
      return scene;
    }));
  }, [selectedSceneId]);

  const disableGenerate = useMemo(() =>
    isGeneratingVideo
    || !(isVideoChanged(scenes, videoSettings))
    || haveTextError, [haveTextError, isGeneratingVideo, scenes, videoSettings]);

  return {
    video,
    setVideo,
    selectedSceneId,
    setSelectedSceneId,
    scenes,
    onSceneSelected,
    setScenes,
    selectedScene,
    onImageUpdated,
    onLogoUpdated,
    onScenesUpdated,
    onFontsUpdated,
    onPalettesUpdated,
    disableGenerate,
    isGeneratingVideo,
    handleGenerate,
    generateError,
    setGenerateError,
    textErrorForSelectedScene,
    videoSettings,
    setVideoSettings,
    brandKit,
    palettesState,
    fontsState,
    audioState,
    setAudioState,
    recommendedAssets,
    isLoadingRecommendedAssets,
    videoUrl,
    copilotRecommendedAssets,
    ariaLiveVideoGenerateMessage,
    addTask,
    cancelTask,
    updatedClips,
    inProgressTaskList,
    onAnimationToggled,
    animationToggleState,
  };
};
